package com.hyperether.goodjob.navigation

import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.DrawerState
import androidx.compose.material3.DrawerValue
import androidx.compose.material3.rememberDrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalDensity
import androidx.navigation.NavController
import androidx.navigation.NavDestination
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.toRoute
import com.hyperether.goodjob.CommonModule
import com.hyperether.goodjob.containerSize
import com.hyperether.goodjob.containerSizeDp
import com.hyperether.goodjob.dpToSizeInPx
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.managers.NetworkManager
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.models.UserStatus
import com.hyperether.goodjob.navigation.NavTransitions.getContactDetailsEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getContactDetailsExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getContactsEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getContactsExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getDashboardEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getDashboardExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getJobDetailsEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getJobDetailsExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getJobsEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getJobsExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getPlacesEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getPlacesExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getPopEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getPopExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getSchedulerEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getSchedulerExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getUserDetailsEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getUserDetailsExitTransition
import com.hyperether.goodjob.navigation.NavTransitions.getUsersEnterTransition
import com.hyperether.goodjob.navigation.NavTransitions.getUsersExitTransition
import com.hyperether.goodjob.repository.Repository
import com.hyperether.goodjob.repository.prefs.PrefsManager
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.admin
import com.hyperether.goodjob.resources.employee
import com.hyperether.goodjob.resources.manager
import com.hyperether.goodjob.resources.user_status_active
import com.hyperether.goodjob.resources.user_status_inactive
import com.hyperether.goodjob.resources.user_status_pending
import com.hyperether.goodjob.scenes.addNew.AddContactViewModel
import com.hyperether.goodjob.scenes.addNew.AddJobViewModel
import com.hyperether.goodjob.scenes.addNew.AddNew
import com.hyperether.goodjob.scenes.addNew.AddNewContact
import com.hyperether.goodjob.scenes.addNew.AddNewJobScreen
import com.hyperether.goodjob.scenes.addNew.AddNewUser
import com.hyperether.goodjob.scenes.addNew.AddNewViewModel
import com.hyperether.goodjob.scenes.addNew.AddUserViewModel
import com.hyperether.goodjob.scenes.components.NoInternetPopup
import com.hyperether.goodjob.scenes.components.UserRestrictionPopUps
import com.hyperether.goodjob.scenes.components.drawer.DrawerComponent
import com.hyperether.goodjob.scenes.contacts.ContactDetails
import com.hyperether.goodjob.scenes.contacts.ContactsScreen
import com.hyperether.goodjob.scenes.contacts.ContactsViewModel
import com.hyperether.goodjob.scenes.contacts.site.AddNewSite
import com.hyperether.goodjob.scenes.dashboard.DashboardMapScreen
import com.hyperether.goodjob.scenes.dashboard.DashboardScreen
import com.hyperether.goodjob.scenes.dashboard.DashboardViewModel
import com.hyperether.goodjob.scenes.jobs.JobDetails
import com.hyperether.goodjob.scenes.jobs.JobDetailsViewModel
import com.hyperether.goodjob.scenes.jobs.JobListViewModel
import com.hyperether.goodjob.scenes.jobs.JobsScreen
import com.hyperether.goodjob.scenes.jobs.JobsWeb
import com.hyperether.goodjob.scenes.landing.LandingPage
import com.hyperether.goodjob.scenes.map.MapScreen
import com.hyperether.goodjob.scenes.map.MapViewModel
import com.hyperether.goodjob.scenes.notifications.NotificationsScreen
import com.hyperether.goodjob.scenes.notifications.NotificationsViewModel
import com.hyperether.goodjob.scenes.onboarding.OnboardingScreen
import com.hyperether.goodjob.scenes.pricing.CancelSubscriptionScreen
import com.hyperether.goodjob.scenes.pricing.PricingScreen
import com.hyperether.goodjob.scenes.pricing.PricingViewModel
import com.hyperether.goodjob.scenes.profile.ProfileSettings
import com.hyperether.goodjob.scenes.profile.ProfileViewModel
import com.hyperether.goodjob.scenes.profile.SettingsWeb
import com.hyperether.goodjob.scenes.register.RegisterScreen
import com.hyperether.goodjob.scenes.register.RegisterViewModel
import com.hyperether.goodjob.scenes.scheduler.SchedulerScreen
import com.hyperether.goodjob.scenes.scheduler.SchedulerViewModel
import com.hyperether.goodjob.scenes.splash.SplashScreen
import com.hyperether.goodjob.scenes.user.UserDetailsScreen
import com.hyperether.goodjob.scenes.user.UserViewModel
import com.hyperether.goodjob.scenes.user.UsersScreen
import com.hyperether.goodjob.scenes.workspace.AddNewWorkspaceScreen
import com.hyperether.goodjob.scenes.workspace.WorkspaceScreen
import com.hyperether.goodjob.scenes.workspace.WorkspaceViewModel
import com.hyperether.goodjob.util.Constants.DEFAULT_CONTACT_ID
import com.hyperether.goodjob.util.Constants.DEFAULT_EMPLOYEE_ID
import com.hyperether.goodjob.util.Constants.DEFAULT_JOB_ID
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.resources.stringResource

@Composable
fun NavGraph(
    navController: NavHostController,
    commonModule: CommonModule,
    modifier: Modifier,
    currentRoute: RouteScreen,
    drawerState: DrawerState,
    onChoosePlanClick: (Double, String) -> Unit,
    onUploadDocumentClick: (String, DocumentType) -> Unit,
    onOpenPdf: (String) -> Unit
) {
    val prefsManager: PrefsManager = commonModule.prefsManager
    val networkManager: NetworkManager = commonModule.networkManager
    val repository: Repository = commonModule.repository
    val isManagerNumberExceeded = prefsManager.managerNumberExceeded
    val isEmployeeNumberExceeded = prefsManager.employeeNumberExceeded

    @Composable
    fun WithNavigationRestriction(
        content: @Composable () -> Unit
    ) {
        val isConnected = remember { networkManager.isConnected() }

        when {
            !isConnected -> {
                NoInternetPopup(navController)
            }

            isEmployeeNumberExceeded.value || isManagerNumberExceeded.value -> {
                UserRestrictionPopUps(
                    isEmployeeNumberExceeded = isEmployeeNumberExceeded,
                    isManagerNumberExceeded = isManagerNumberExceeded,
                    navHostController = navController
                )
            }

            else -> {
                content()
            }
        }
    }

    NavHost(
        navController = navController,
        startDestination = currentRoute,
        modifier = modifier,
        enterTransition = {
            getEnterTransition()
        },
        exitTransition = {
            getExitTransition()
        },
        popEnterTransition = {
            getPopEnterTransition()
        },
        popExitTransition = {
            getPopExitTransition()
        }
    ) {
        composable<Splash> {
            SplashScreen(navController)
        }

        composable<Onboarding> {
            OnboardingScreen(navController, prefsManager)
        }

        composable<Register> {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                RegisterScreen(
                    isMobileView = isMobileOrNarrowScreen,
                    registerViewModel = commonModule.registerViewModel,
                    navHostController = navController,
                    workspaceViewModel = commonModule.workspaceViewModel,
                    pricingViewModel = commonModule.pricingViewModel,
                )
            }
        }

        composable<Pricing> {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                PricingScreen(
                    isMobileOrNarrowScreen,
                    commonModule.pricingViewModel,
                    navController,
                    onChoosePlanClick
                )
            }
        }

        composable<CancelSubscriptionScreen> {
            CancelSubscriptionScreen(commonModule.pricingViewModel, navController)
        }

        composable<Workspace> {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                WorkspaceScreen(
                    isMobileView = isMobileOrNarrowScreen,
                    workspaceViewModel = commonModule.workspaceViewModel,
                    continueToDashboard = {
                        navController.navigate(Dashboard) {
                            popUpTo<Workspace> {
                                inclusive = true
                                saveState = false
                            }
                            launchSingleTop = true
                        }
                    },
                    goToLanding = {
                        navController.navigate(Landing) {
                            popUpTo<Workspace> {
                                inclusive = true
                                saveState = false
                            }
                            launchSingleTop = true
                        }
                    },
                    addNewWorkspace = {
                        navController.navigate(AddNewWorkspace) {
                            popUpTo<Workspace> {
                                inclusive = true
                                saveState = false
                            }
                            launchSingleTop = true
                        }
                    },
                    userViewModel = commonModule.userViewModel,
                    onLogout = {
                        commonModule.logout {
                            navController.navigate(Register) {
                                popUpTo(0) {
                                    inclusive = true
                                }
                                launchSingleTop = true
                            }
                        }
                    }
                )
            }
        }

        composable<AddNewWorkspace> {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                AddNewWorkspaceScreen(
                    isMobileView = isMobileOrNarrowScreen,
                    workspaceViewModel = commonModule.workspaceViewModel,
                    onChooseExistingWorkspace = {
                        navController.navigate(Workspace) {
                            popUpTo<AddNewWorkspace> {
                                inclusive = true
                                saveState = false
                            }
                            launchSingleTop = true
                        }
                    }
                )
            }
        }

        composable<Dashboard>(
            enterTransition = {
                getDashboardEnterTransition()
            },
            exitTransition = {
                getDashboardExitTransition()
            }
        ) {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                DashboardScreen(
                    isMobileView = isMobileOrNarrowScreen,
                    navHostController = navController,
                    dashboardViewModel = commonModule.dashboardViewModel,
                    mapViewModel = commonModule.mapViewModel,
                    drawerState = drawerState,
                    screenWidth = maxWidth.value,
                    screenHeight = maxHeight.value
                )
            }
        }

        composable<JobsWeb> {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                SelectionContainer {
                    JobsWeb(
                        navController = navController,
                        viewModel = commonModule.jobListViewModel,
                        isMobileView = isMobileOrNarrowScreen
                    )
                }
            }
        }

        composable<AddNew> {
            WithNavigationRestriction {
                AddNew(navController, commonModule.addNewViewModel)
            }
        }

        composable<AddNewUser> { backStackEntry ->
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                val addNewUser = backStackEntry.toRoute<AddNewUser>()
                val employeeId = addNewUser.employeeId.ifEmpty { DEFAULT_EMPLOYEE_ID }

                // Allow user editing - in order to inactivate users over limit
                if (employeeId == DEFAULT_EMPLOYEE_ID) {
                    WithNavigationRestriction {
                        AddNewUser(
                            employeeId,
                            isMobileOrNarrowScreen,
                            navController,
                            commonModule.addUserViewModel
                        )
                    }
                } else {
                    AddNewUser(
                        employeeId,
                        isMobileOrNarrowScreen,
                        navController,
                        commonModule.addUserViewModel
                    )
                }
            }
        }

        composable<Users>(
            enterTransition = {
                getUsersEnterTransition(initial = initialState.destination.route)
            },
            exitTransition = {
                getUsersExitTransition(
                    initial = initialState.destination.route,
                    target = targetState.destination.route
                )
            }
        ) {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                UsersScreen(
                    isMobileView = isMobileOrNarrowScreen,
                    userViewModel = commonModule.userViewModel,
                    navController = navController,
                    prefsManager = prefsManager,
                    drawerState = drawerState,
                    screenHeight = maxHeight.value
                )
            }
        }

        composable<UserDetails>(
            enterTransition = {
                getUserDetailsEnterTransition(initial = initialState.destination.route)
            },
            exitTransition = {
                getUserDetailsExitTransition(
                    initial = initialState.destination.route,
                    target = targetState.destination.route
                )
            }
        ) { backStackEntry ->
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                val userDetails = backStackEntry.toRoute<UserDetails>()
                val employeeId = userDetails.employeeId.ifEmpty { DEFAULT_EMPLOYEE_ID }

                UserDetailsScreen(
                    userId = employeeId,
                    isMobileView = isMobileOrNarrowScreen,
                    viewModel = commonModule.userViewModel,
                    navController = navController,
                    boxWidth = maxWidth
                )
            }
        }

        composable<AddNewJob> { backStackEntry ->
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                val addNewJob = backStackEntry.toRoute<AddNewJob>()
                val jobId = addNewJob.jobId.ifEmpty { DEFAULT_JOB_ID }

                WithNavigationRestriction {
                    AddNewJobScreen(
                        jobId,
                        isMobileOrNarrowScreen,
                        commonModule.addJobViewModel,
                        navController,
                        onUploadDocumentClick
                    )
                }
            }
        }

        composable<Jobs>(
            enterTransition = {
                getJobsEnterTransition(initial = initialState.destination.route)
            },
            exitTransition = {
                getJobsExitTransition(
                    initial = initialState.destination.route,
                    target = targetState.destination.route
                )
            }) {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                JobsScreen(
                    isMobileOrNarrowScreen,
                    commonModule.jobListViewModel,
                    navController,
                    drawerState,
                    prefsManager
                )
            }
        }

        composable<AddNewContact> { backStackEntry ->
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                val addNewContact = backStackEntry.toRoute<AddNewContact>()
                val contactId = addNewContact.contactId.ifEmpty { DEFAULT_CONTACT_ID }

                WithNavigationRestriction {
                    AddNewContact(
                        contactId,
                        commonModule.addContactViewModel,
                        navController,
                        isMobileOrNarrowScreen
                    )
                }
            }
        }

        composable<JobDetails>(
            enterTransition = {
                getJobDetailsEnterTransition(initial = initialState.destination.route)
            },
            exitTransition = {
                getJobDetailsExitTransition(
                    initial = initialState.destination.route,
                    target = targetState.destination.route
                )
            }) { backStackEntry ->
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                containerSizeDp.value = maxWidth
                com.hyperether.planner.util.containerSizeDp.value = maxWidth
                val jobDetails = backStackEntry.toRoute<JobDetails>()
                val jobId = jobDetails.jobId

                val viewModel: JobDetailsViewModel = remember { JobDetailsViewModel(repository) }
                JobDetails(
                    isMobileOrNarrowScreen,
                    jobId,
                    viewModel,
                    navController,
                    onOpenPdf,
                    onUploadDocumentClick
                )
            }
        }

        composable<Contacts>(
            enterTransition = {
                getContactsEnterTransition(initial = initialState.destination.route)
            },
            exitTransition = {
                getContactsExitTransition(
                    initial = initialState.destination.route,
                    target = targetState.destination.route
                )
            }) {
            BoxWithConstraints {
                val isMobileScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                ContactsScreen(
                    navController,
                    isMobileScreen,
                    commonModule.contactsViewModel,
                    drawerState,
                    prefsManager
                )
            }
        }

        composable<AddNewSite> { backStackEntry ->
            BoxWithConstraints {
                val addNewSite = backStackEntry.toRoute<AddNewSite>()
                val contactId = addNewSite.contactId
                val siteId = addNewSite.siteId

                val isMobileScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                WithNavigationRestriction {
                    siteId?.let {
                        AddNewSite(
                            contactId,
                            it,
                            commonModule.contactsViewModel,
                            navController,
                            isMobileScreen
                        )
                    }
                }
            }
        }

        composable<ContactDetails>(
            enterTransition = {
                getContactDetailsEnterTransition(initial = initialState.destination.route)
            },
            exitTransition = {
                getContactDetailsExitTransition(
                    initial = initialState.destination.route,
                    target = targetState.destination.route
                )
            }) { backStackEntry ->
            BoxWithConstraints {
                val contactDetails = backStackEntry.toRoute<ContactDetails>()
                val contactId = contactDetails.contactId

                val isMobileScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                ContactDetails(
                    contactId,
                    navController,
                    commonModule.contactsViewModel,
                    isMobileScreen
                )
            }
        }

        composable<Landing> {
            BoxWithConstraints {
                val density = LocalDensity.current
                val sizeInPx = remember(maxWidth, maxHeight) {
                    dpToSizeInPx(maxWidth, maxHeight, density)
                }
                containerSize.value = sizeInPx
                com.hyperether.planner.util.containerSize.value = sizeInPx
                // Cache the isMobileOrNarrowScreen value using remember so it's not recomputed every time

                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }

                LandingPage(
                    isMobileOrNarrowScreen,
                    commonModule.pricingViewModel,
                    continueToRegister = {
                        navController.navigate(Register)
                    },
                    onOpenPdf = onOpenPdf
                )
            }
        }

        composable<Scheduler>(
            enterTransition = {
                getSchedulerEnterTransition(initial = initialState.destination.route)
            },
            exitTransition = {
                getSchedulerExitTransition(
                    initial = initialState.destination.route,
                    target = targetState.destination.route
                )
            }) {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                SchedulerScreen(
                    commonModule.schedulerViewModel,
                    navController,
                    drawerState,
                    prefsManager,
                    isMobileOrNarrowScreen,
                    screenWidth = maxWidth.value,
                    screenHeight = maxHeight.value
                )
            }
        }

        composable<ProfileSettings> {
            val profileViewModel: ProfileViewModel = remember { ProfileViewModel(repository) }
            ProfileSettings(navController, prefsManager, profileViewModel)
        }
        composable<SettingsWeb> {
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                val profileViewModel: ProfileViewModel = remember { ProfileViewModel(repository) }
                SelectionContainer {
                    SettingsWeb(
                        isMobileOrNarrowScreen,
                        navController,
                        prefsManager,
                        commonModule.pricingViewModel,
                        profileViewModel,
                        onChoosePlanClick
                    )
                }
            }
        }

        composable<Map>(
            enterTransition = {
                getPlacesEnterTransition(initial = initialState.destination.route)
            },
            exitTransition = {
                getPlacesExitTransition(
                    initial = initialState.destination.route,
                    target = targetState.destination.route
                )
            }
        ) {
//            mapViewModel.initViewModel()
//            mapViewModel.initMapViewModel()
            BoxWithConstraints {
                val isMobileOrNarrowScreen = remember(maxWidth) {
                    getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
                }
                MapScreen(
                    commonModule.mapViewModel,
                    navController,
                    drawerState,
                    prefsManager,
                    isMobileOrNarrowScreen
                )
            }
        }

        composable<DashboardMapScreen> {
            DashboardMapScreen(commonModule.dashboardMapViewModel, navController)
        }

        composable<Notifications> {
            val viewModel: NotificationsViewModel =
                remember { NotificationsViewModel(repository) }
            NotificationsScreen(viewModel, navController, drawerState, prefsManager)
        }
    }
}

@Composable
fun Container(
    navController: NavHostController,
    commonModule: CommonModule,
    onChoosePlanClick: (Double, String) -> Unit,
    onLogout: () -> Unit,
    onUploadDocumentClick: (String, DocumentType) -> Unit,
    onOpenPdf: (String) -> Unit,
    currentRoute: RouteScreen,
    onDestinationChanged: (NavDestination) -> Unit,
) {
    val isBottomNavigationBarVisible = remember { mutableStateOf(false) }
    val isWebNavigationDrawerVisible = remember { mutableStateOf(false) }

    val repository = commonModule.repository

    val workspaceViewModel: WorkspaceViewModel = remember { WorkspaceViewModel(repository) }
    val pricingViewModel: PricingViewModel = remember { PricingViewModel(repository) }
    val registerViewModel: RegisterViewModel = remember { RegisterViewModel(repository) }
    val userViewModel: UserViewModel = remember { UserViewModel(repository) }
    val addNewViewModel: AddNewViewModel = remember { AddNewViewModel(repository) }
    val addContactViewModel: AddContactViewModel = remember { AddContactViewModel(repository) }
    val addUserViewModel: AddUserViewModel = remember { AddUserViewModel(repository) }
    val addJobViewModel: AddJobViewModel = remember { AddJobViewModel(repository) }
    val jobListViewModel: JobListViewModel = remember { JobListViewModel(repository) }
    val dashboardViewModel: DashboardViewModel = remember { DashboardViewModel(repository) }
    val schedulerViewModel: SchedulerViewModel = remember { SchedulerViewModel(repository) }
    val dashboardMapViewModel: MapViewModel = remember { MapViewModel(repository) }
    val contactsViewModel: ContactsViewModel = remember { ContactsViewModel(repository) }
    val mapViewModel: MapViewModel = remember { MapViewModel(repository) }

    commonModule.workspaceViewModel = workspaceViewModel
    commonModule.pricingViewModel = pricingViewModel
    commonModule.registerViewModel = registerViewModel
    commonModule.userViewModel = userViewModel
    commonModule.addNewViewModel = addNewViewModel
    commonModule.addContactViewModel = addContactViewModel
    commonModule.addUserViewModel = addUserViewModel
    commonModule.addJobViewModel = addJobViewModel
    commonModule.jobListViewModel = jobListViewModel
    commonModule.dashboardViewModel = dashboardViewModel
    commonModule.schedulerViewModel = schedulerViewModel
    commonModule.dashboardMapViewModel = dashboardMapViewModel
    commonModule.contactsViewModel = contactsViewModel
    commonModule.mapViewModel = mapViewModel

    val hiddenBottomNavigationRoutes = remember {
        listOf(
            "profile_settings",
            "pricing",
            "register",
            "add_new_employee",
            "add_new",
            "splash",
            "landing",
            "workspace",
            "about_contact",
            "add_new_contact",
            "add_new_job",
            "add_new_workspace",
            "onboarding",
            "add_new_site",
            "job_details",
            "contact_details",
            "employee_details"
        )
    }

    val hiddenWebNavigationRoutes = remember {
        listOf(
            "pricing",
            "register",
            "splash",
            "landing",
            "workspace",
            "add_new_workspace",
            "onboarding"
        )
    }

    LaunchedEffect(navController) {
        navController.addOnDestinationChangedListener { _, destination, _ ->
            val trimmedDestinationBaseRoute = destination.route?.substringBefore("?")
            val trimmedDestinationRoute = trimmedDestinationBaseRoute?.substringBefore("/")
            println("navigation change with destination: $destination trimmedDestinationRoute:$trimmedDestinationRoute")
            isBottomNavigationBarVisible.value = trimmedDestinationRoute != null &&
                    hiddenBottomNavigationRoutes.none { route ->
                        trimmedDestinationRoute == route
                    }

            isWebNavigationDrawerVisible.value = trimmedDestinationRoute != null &&
                    hiddenWebNavigationRoutes.none { route ->
                        trimmedDestinationRoute == route
                    }

            onDestinationChanged(destination)
        }
    }

    commonModule.userViewModel.roleMap = mapOf(
        stringResource(Res.string.admin) to Role.admin.name,
        stringResource(Res.string.manager) to Role.manager.name,
        stringResource(Res.string.employee) to Role.employee.name,
    )
    commonModule.userViewModel.userStatusMap = mapOf(
        stringResource(Res.string.user_status_active) to UserStatus.active.name,
        stringResource(Res.string.user_status_pending) to UserStatus.pending.name,
        stringResource(Res.string.user_status_inactive) to UserStatus.inactive.name,
    )
    BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
        val drawerState = rememberDrawerState(initialValue = DrawerValue.Closed)

        LaunchedEffect(commonModule.shouldCloseDrawer.value) {
            if (commonModule.shouldCloseDrawer.value) {
                drawerState.close()
                commonModule.shouldCloseDrawer.value = false
            }
        }

        val isMobileOrNarrowScreen = remember(maxWidth) {
            getPlatformChecker().isMobile() || getPlatformChecker().isMobileWebView()
        }
        if (isMobileOrNarrowScreen) {
            Column(modifier = Modifier.fillMaxSize()) {
                DrawerComponent(
                    navController = navController,
                    commonModule = commonModule,
                    modifier = Modifier.weight(1f),
                    onChoosePlanClick = onChoosePlanClick,
                    onLogout = onLogout,
                    startRoute = commonModule.getStartRoute(),
                    isBottomNavigationBarVisible = isBottomNavigationBarVisible.value,
                    onUploadDocumentClick = onUploadDocumentClick,
                    onOpenPdf = onOpenPdf,
                    drawerState = drawerState
                )
            }
        } else {
            Row(modifier = Modifier.fillMaxSize()) {
                if (isWebNavigationDrawerVisible.value) {
                    WebNav(
                        navController,
                        commonModule.workspaceViewModel,
                        commonModule.prefsManager,
                        onLogout
                    )
                }
                NavGraph(
                    navController,
                    commonModule,
                    modifier = Modifier.weight(1f),
                    currentRoute,
                    drawerState = drawerState,
                    onChoosePlanClick,
                    onUploadDocumentClick,
                    onOpenPdf = onOpenPdf
                )
            }
        }
    }
}

fun NavController.safeNavigate(target: RouteScreen) {
    currentDestination?.let {
        val current = it.route
        val desired = target.route

        if (current == desired) return

        navigate(target) {
            popUpTo<Dashboard> {
                saveState = true
            }
            launchSingleTop = true
            restoreState = true
        }
    }
}